import { createSlice } from '@reduxjs/toolkit';

const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    customer: null,
    isLoggedIn: false
  },
  reducers: {
    setCustomer: (state, action) => {
      state.customer = action.payload;
      state.isLoggedIn = !!action.payload;
    },
    clearCustomer: (state) => {
      state.customer = null;
      state.isLoggedIn = false;
    }
  }
});

export const { setCustomer, clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;





